module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2657079836/src/src/app/common/auto-logout/auto-logout.component.html
// module id = ../../../../../src/app/common/auto-logout/auto-logout.component.html
// module chunks = main